import {
  api_url,
  legendLabelsBoxHeightLine,
  configChartsColorPalettes,
  yRight,
  partSumpTrajectory,
  popupInformation,
  defaultBarPercentage,
  defaultDatalabelsProperties,
  defaultTicksCustomValue,
} from "../../../utils";

const EmissionCo2 = {
  checked: false,
  titleSideBar: "Emisiones de CO2",
  titleIndicator: "SUMP Trajectory Content.charts.EmissionCo2.title",
  popupInformation: {
    status: "false",
    text: popupInformation[partSumpTrajectory]["emissionCo2"],
  },
  keyFigure: {
    typeUpdate: "year", // year or geographical_area
    label: "",
    url: "",
    separator: "",
    position: "",
  },
  charts: [
    {
      typeChart: "area",
      typeLabels: "geographical_areas", // years or geographical_areas
      multiYearGeographicalArea: true,
      singleYearGeographicalAreaType: "geographical_area", // year or geographical_area : MUST BE CONSISTENT WITH THE TYPE_LABEL ARGUMENT OF THE DATASET URL
      titleChart: "",
      titleDisplay: "true",
      legendDisplay: "true",
      legendCustom: "false",
      legendLabelsBoxHeight: legendLabelsBoxHeightLine,
      maintainAspectRatio: true,
      indexAxis: "x", // x or y
      heightChart: "350",
      widthChart: "600",
      i18nKeyLabels: "SUMP Trajectory Content.charts.EmissionCo2.axis.labelsX",
      scales: {
        x: {
          type: "category",
          display: true,
          stacked: true,
          titleDisplay: false,
          titleText: "",
          gridDisplay: false,
          beginAtZero: false,
          ticks: {
            display: true,
            value: defaultTicksCustomValue,
          },
        },
        y: {
          type: "linear",
          display: true,
          stacked: true,
          titleDisplay: true,
          titleText: "SUMP Trajectory Content.charts.EmissionCo2.axis.titleY",
          gridDisplay: true,
          beginAtZero: true,
          max: 600,
          ticks: {
            display: true,
            value: defaultTicksCustomValue,
          },
        },
        yRight: yRight,
      },
      annotationsProperties: {
        annotation1: undefined,
        annotation2: undefined,
      },
      keyFigure: {
        typeUpdate: "year", // year or geographical_area
        label: "",
        url: "",
        separator: "",
        position: "",
      },
      datasets: [
        {
          type: "bar",
          label:
            "SUMP Trajectory Content.charts.EmissionCo2.legend.HIDETOOLTIPIFZEROAutos",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_geographical_areas&indicator=emission_co2&trend=projection&chart=emission_co2_autos&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes["trajectory_emission_co2"]
              .backgroundColor[1],
          borderColor:
            configChartsColorPalettes["trajectory_emission_co2"].borderColor[1],
          borderWidth: 1,
          pointStyle: "circle",
          pointRadius: 3,
          spanGaps: true,
          legendCustomCssClass: "",
          fill: false,
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: defaultBarPercentage,
          categoryPercentage: 0.4,
          datalabelsProperties: defaultDatalabelsProperties,
        },
        {
          type: "bar",
          label:
            "SUMP Trajectory Content.charts.EmissionCo2.legend.HIDETOOLTIPIFZEROMotos",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_geographical_areas&indicator=emission_co2&trend=projection&chart=emission_co2_motos&chart_data=True&chart_multi_year_geographical_area=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes["trajectory_emission_co2"]
              .backgroundColor[2],
          borderColor:
            configChartsColorPalettes["trajectory_emission_co2"].borderColor[2],
          borderWidth: 1,
          pointStyle: "circle",
          pointRadius: 3,
          spanGaps: true,
          legendCustomCssClass: "",
          fill: false,
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: defaultBarPercentage,
          categoryPercentage: 0.4,
          datalabelsProperties: defaultDatalabelsProperties,
        },
        {
          type: "bar",
          label:
            "SUMP Trajectory Content.charts.EmissionCo2.legend.HIDETOOLTIPIFZEROTaxis",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_geographical_areas&indicator=emission_co2&trend=projection&chart=emission_co2_taxis&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes["trajectory_emission_co2"]
              .backgroundColor[0],
          borderColor:
            configChartsColorPalettes["trajectory_emission_co2"].borderColor[0],
          borderWidth: 1,
          pointStyle: "circle",
          pointRadius: 3,
          spanGaps: true,
          legendCustomCssClass: "",
          fill: false,
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: defaultBarPercentage,
          categoryPercentage: 0.4,
          datalabelsProperties: defaultDatalabelsProperties,
        },
        {
          type: "bar",
          label:
            "SUMP Trajectory Content.charts.EmissionCo2.legend.HIDETOOLTIPIFZEROBus convencional",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_geographical_areas&indicator=emission_co2&trend=projection&chart=emission_co2_bus_convencional&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes["trajectory_emission_co2"]
              .backgroundColor[3],
          borderColor:
            configChartsColorPalettes["trajectory_emission_co2"].borderColor[3],
          borderWidth: 1,
          pointStyle: "circle",
          pointRadius: 3,
          spanGaps: true,
          legendCustomCssClass: "",
          fill: false,
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: defaultBarPercentage,
          categoryPercentage: 0.4,
          datalabelsProperties: defaultDatalabelsProperties,
        },
        {
          type: "bar",
          label:
            "SUMP Trajectory Content.charts.EmissionCo2.legend.HIDELEGENDHIDETOOLTIPIFZEROAutos",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_geographical_areas&indicator=emission_co2&trend=projection&chart=emission_co2_autos_objective&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_emission_co2_objective_transparency"
            ].backgroundColor[1],
          borderColor:
            configChartsColorPalettes[
              "trajectory_emission_co2_objective_transparency"
            ].borderColor[1],
          borderWidth: 1,
          pointStyle: "circle",
          pointRadius: 3,
          spanGaps: true,
          legendCustomCssClass: "",
          fill: false,
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: defaultBarPercentage,
          categoryPercentage: 0.4,
          datalabelsProperties: defaultDatalabelsProperties,
        },
        {
          type: "bar",
          label:
            "SUMP Trajectory Content.charts.EmissionCo2.legend.HIDELEGENDHIDETOOLTIPIFZEROMotos",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_geographical_areas&indicator=emission_co2&trend=projection&chart=emission_co2_motos_objective&chart_data=True&chart_multi_year_geographical_area=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_emission_co2_objective_transparency"
            ].backgroundColor[2],
          borderColor:
            configChartsColorPalettes[
              "trajectory_emission_co2_objective_transparency"
            ].borderColor[2],
          borderWidth: 1,
          pointStyle: "circle",
          pointRadius: 3,
          spanGaps: true,
          legendCustomCssClass: "",
          fill: false,
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: defaultBarPercentage,
          categoryPercentage: 0.4,
          datalabelsProperties: defaultDatalabelsProperties,
        },
        {
          type: "bar",
          label:
            "SUMP Trajectory Content.charts.EmissionCo2.legend.HIDELEGENDHIDETOOLTIPIFZEROTaxis",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_geographical_areas&indicator=emission_co2&trend=projection&chart=emission_co2_taxis_objective&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_emission_co2_objective_transparency"
            ].backgroundColor[0],
          borderColor:
            configChartsColorPalettes[
              "trajectory_emission_co2_objective_transparency"
            ].borderColor[0],
          borderWidth: 1,
          pointStyle: "circle",
          pointRadius: 3,
          spanGaps: true,
          legendCustomCssClass: "",
          fill: false,
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: defaultBarPercentage,
          categoryPercentage: 0.4,
          datalabelsProperties: defaultDatalabelsProperties,
        },
        {
          type: "bar",
          label:
            "SUMP Trajectory Content.charts.EmissionCo2.legend.HIDELEGENDHIDETOOLTIPIFZEROBus convencional",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_geographical_areas&indicator=emission_co2&trend=projection&chart=emission_co2_bus_convencional_objective&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_emission_co2_objective_transparency"
            ].backgroundColor[3],
          borderColor:
            configChartsColorPalettes[
              "trajectory_emission_co2_objective_transparency"
            ].borderColor[3],
          borderWidth: 1,
          pointStyle: "circle",
          pointRadius: 3,
          spanGaps: true,
          legendCustomCssClass: "",
          fill: false,
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: defaultBarPercentage,
          categoryPercentage: 0.4,
          datalabelsProperties: defaultDatalabelsProperties,
        },
      ],
    },
  ],
};

export default EmissionCo2;
